import React from 'react'

function Politica() {
    return (
        <div>
            <h1>Política de Privacidad y tratamiento de datos</h1>
        </div>
    )
}

export default Politica